import { useEffect, useState } from 'react';
import axios from 'axios';
import { useSearchParams, useNavigate, Link,useParams  } from 'react-router-dom';
import Lottie from "react-lottie";
import * as successVerification from "../lottie/lottie_success.json";
import * as failedVerification from "../lottie/lottie_failed.json";
import QRCheckerNotaryAcknowledgment from './QRCheckerNotaryAcknowledgment';

const QRChecker = () => {



    const [formData, setFormData] = useState({
   
      // PAGE 1
      documentName : '',
      documentTitle: '',
      documentNo   : '',
      pageNo       : '',
      bookNo       : '',
  
      requestFor:'self',
      relationshipToBeneficiary:'',
  
      insidePhilippines:'',
      question1:'',
      question2:'',
      question3:'',
      question4:'',
  
      // PAGE 2
      idType:'',
      idNo:'',
      dateIssued:'',
      governmentId:'',
      scannedImages:[],
      signature:'',
  
  
      // PAGE3
      firstName:'',
      middleName:'',
      lastName:'',
      birthday:null,
      gender:'',
      country:'Philippines',
      region:'',
      province:'',
      cityMunicipality:'',
      barangay:'',
      contactNumber:'',
      email:'',
  
      // PAGE4
      amount:'',
      referenceNo:'',
      datePaid:'',
      paymentMethod:'CASH',
      description:'',
  
      transaction_status:'PAID',
  
      // PAGE 5
      lawyerImage:'',
      isLawyerImageIsLink:true,
    });






  // Use React Router's useParams hook to extract the 'id' from the path
  const { id } = useParams();  // Extract the `id` from the path like /qr-checker/:id/
  const navigate = useNavigate();

  const [message, setMessage] = useState('Verifying...');
  const [success, setSuccess] = useState(null);

  useEffect(() => {
    const check = async () => {
      try {
        // Make a POST request to the backend to verify the transaction based on the path parameter 'id'
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/qr-checker/${id}/`);
        
        console.log("response", response);
        setFormData(response.data.transaction)
        setSuccess(true);
        setMessage(response.data.success || 'Email verified successfully.');
      } catch (error) {
        setSuccess(false);
        const msg = error.response?.data?.message || 'Verification failed.';
        setMessage(msg);
      }
    };

    if (id) {
      check();
    } else {
      setSuccess(false);
      setMessage('Transaction not found.');
    }
  }, [id, navigate]);

  useEffect(() => {
    console.log("id", id); // Logs the id from the URL to ensure it's being correctly extracted
  }, [id]);

  // Lottie animation options
  const defaultOptionsLottieSuccess = {
    loop: true,
    autoplay: true,
    animationData: successVerification,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const defaultOptionsLottieFailed = {
    loop: true,
    autoplay: true,
    animationData: failedVerification,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };


  return (
  
          
    <div className="authentication-wrapper authentication-basic container-p-y bg-white">
      <div className="row m-">
        <div className="rounded-3 p-5 p-lg-4 p-md-4 shadow-md-up bg-white" style={{zIndex:12}} >
          <span className={`mb-3 ${success ? 'text-success' : 'text-danger fs-1'}`}>
            {success === null ? 'Verifying...' : success ? 
            <>

                <QRCheckerNotaryAcknowledgment formData={formData} />
             
               
                 <Link to="/iusevolutione/login"  className="btn btn-primary text-nowrap mt-4" >
                 Go to login
                </Link>

            </>
            : 
            <>
              <h4 className="mb-2">Checking Transaction.🔒</h4>
                <Lottie isClickToPauseDisabled={true} options={defaultOptionsLottieFailed} height={250} width={250} />
                <span className=" fw-bold fs-6 mt-n4 mb-2 text-uppercase" style={{ letterSpacing: "1px" }} >
                  NO TRANSACTION!<br/>
                  {message}
                </span>
                <br/>


                <Link to="/iusevolutione/login"  className="btn btn-primary text-nowrap mt-4 d-none" >
                 Go to login
                </Link>


            </>       
            }
          </span>
        </div>
      </div>
    </div>
    );
};

export default QRChecker;
